/*
 Distinct versions of opt-in checkboxes for everything POST v3 landing pages.
 */
export { OptCheckboxes } from './OptCheckboxes';
